/**
 * TanStack Query key factories, nested style to match @kolab/dms-base conventions.
 * Every factory accepts `params?: Record<string, unknown>` for filter/pagination scoping.
 */

const nested = <TName extends string>(name: TName) => ({
  all: [name] as const,
  lists: () => [name, 'list'] as const,
  list: (params?: Record<string, unknown>) => [name, 'list', params] as const,
  details: () => [name, 'detail'] as const,
  detail: (id: string) => [name, 'detail', id] as const,
})

export const distributorKeys = nested('distributors')
export const resellerKeys = nested('resellers')
export const userKeys = nested('users')
export const roleKeys = nested('roles')
export const licenseProductKeys = nested('license-products')
export const distributorLicenseKeys = nested('distributor-licenses')
export const resellerLicenseKeys = nested('reseller-licenses')
export const deviceLicenseKeys = nested('device-licenses')

// Device-ops (monolith)
export const deviceKeys = nested('devices')
export const pingKeys = nested('pings')
export const geoKeys = nested('geolocations')
export const commandKeys = nested('commands')
export const dashboardStatsKeys = {
  all: ['dashboard-stats'] as const,
  detail: () => ['dashboard-stats', 'detail'] as const,
}

export const configKeys = {
  all: ['config'] as const,
  detail: (scope: string, ownerId?: string) => ['config', 'detail', scope, ownerId ?? ''] as const,
  merged: (scope: string, ownerId?: string) => ['config', 'merged', scope, ownerId ?? ''] as const,
}

export const reportKeys = {
  pools: {
    list: (params?: Record<string, unknown>) => ['reports', 'pools', 'list', params] as const,
    detail: (id: string) => ['reports', 'pools', 'detail', id] as const,
  },
  capacity: {
    list: (params?: Record<string, unknown>) => ['reports', 'capacity', 'list', params] as const,
    detail: (id: string) => ['reports', 'capacity', 'detail', id] as const,
  },
  expiring: {
    list: (params?: Record<string, unknown>) => ['reports', 'expiring', 'list', params] as const,
  },
  activitySummary: () => ['reports', 'device-activity-summary'] as const,
  installations: {
    list: (params?: Record<string, unknown>) => ['reports', 'installations', 'list', params] as const,
  },
  lockUnlock: {
    list: (params?: Record<string, unknown>) => ['reports', 'lock-unlock', 'list', params] as const,
  },
}
